import * as React from 'react'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Radio from '@material-ui/core/Radio'
import { IControlProps } from '../form_controls/types'
import {
  GRID_CELLFONTSIZE,
  GRID_CELLPADDING
} from '../form_controls/grids/consts'

import {
  withOneplaceLibraryContext,
  IOneplaceLibraryContextProp
} from '../OneplaceLibraryProvider'
import { IPriorityOptionItem } from '../../models/Ticket'

interface IPriorityControlProps
  extends IControlProps,
    IOneplaceLibraryContextProp {}

export const PriorityControl = withOneplaceLibraryContext(
  class extends React.Component<IPriorityControlProps> {
    static displayName = 'PriorityControl'

    constructor(props: IPriorityControlProps) {
      super(props)
      this.handleChange = this.handleChange.bind(this)
    }

    handleChange(event: React.ChangeEvent<HTMLInputElement>) {
      const newValue = event.target.value
      if (this.props.onFieldChange) {
        this.props.onFieldChange(
          this.props.field.value,
          newValue,
          this.props.form
        )
      }
      this.props.form.setFieldValue(this.props.field.name, newValue)
    }

    render() {
      const t = this.props.ctx.i18next.t

      const options: IPriorityOptionItem[] = [
        { value: 'Critical', label: t('priority_critical') },
        { value: 'High', label: t('priority_high') },
        { value: 'Medium', label: t('priority_medium') },
        { value: 'Low', label: t('priority_low') }
      ]

      if (this.props.gridCell) {
        return (
          <div
            id={this.props.id}
            style={{ padding: GRID_CELLPADDING, fontSize: GRID_CELLFONTSIZE }}
          >
            {this.props.field.value || ''}
          </div>
        )
      } else {
        return (
          <RadioGroup
            value={(this.props.field.value as string) || ''}
            onChange={this.handleChange}
            style={{
              display: 'flex',
              flexDirection: 'row',
              marginTop: 12
            }}
          >
            {options.map((option, idx) => (
              <FormControlLabel
                key={idx}
                value={option.value}
                control={<Radio color='primary' />}
                label={option.label}
              />
            ))}
          </RadioGroup>
        )
      }
    }
  }
)
